import type { ReadonlyRecord } from '../../utils'

import type { AuthenticationInformation, ColumnView, CustomizedTable } from '../../domain'

export interface AuthenticationPersistenceService {
    /**
     * Retrieves persisted authentication information
     * It should NOT check if the token is already expired
     */
    retrieve(): AuthenticationInformation | null

    /**
     * Quietly drops current authentication information
     */
    flush(): void

    /**
     * Persists authentication information
     */
    persist(info: AuthenticationInformation): void
}

export type PersistedTopics = ReadonlyRecord<'selected' | 'custom', readonly string[]>

export interface TopicsPersistenceService {
    retrieveTopics(): PersistedTopics
    persistTopics(topics: PersistedTopics): void
}

export interface TablePersistenceService {
    retrieveTable<L extends ReadonlyRecord<string, unknown>>(id: string): Partial<CustomizedTable<L>>

    /**
     * @param table a partial table will **not** be merged with current persistence
     */
    persistTable<L extends ReadonlyRecord<string, unknown>>(id: string, table: Partial<CustomizedTable<L>>): void

    flush(): void
}

export interface ColumnViewPersistenceService {
    /** The table's saved view, or the default view if none is saved */
    retrieve(id: string): ColumnView
    persist(id: string, view: ColumnView): void
    drop(id: string): void
    flush(): void
}

export interface RecordPanelWidthPersistenceService {
    /** The saved width in px, `null` if none is saved */
    retrieve(): number | null
    /** `null` drops the saved width */
    persist(width: number | null): void
}
